// import {registerFlowForm} from "@/CommonDP/pages/components/launchFlow/flowFormRegister.js";
import globalParams from '@/CommonDP/utils/globalParams';

// 状态
export function statusName(status) {
  switch (status) {
    case "1":
      return "已通过";
    case "2":
      return "审批中";
    case "3":
      return "发起";
    case "4":
      return "重新发起";
    case "5":
      return "已撤回";
    case "0":
      return "已驳回";
    default:
      return "";
  }
}

export function conditionExpr(nodeStatus) {
  switch (nodeStatus) {
    case '1':
      return "  (已同意)";
    case '2':
      return "  (审批中)";
    case '3':
      return "  (发起)";
    case '4':
      return "  (再发起)";
    case '5':
      return "  (已撤回)";
    case '0':
      return "  (已驳回)";
    default:
      break;
  }
}
// 目前有的审批流程类别
export const processTypeList = ["common", "tz", "check", "leave"];

export function mapComponentName(flowKey, formId) {
  if (formId && !processTypeList.some(e => e === flowKey)) {
    return "formCreate";
  }
  return getFormComponentH5(flowKey);
}

export function getFormComponentH5(formKey) {
  return globalParams.get(`flow.formH5.${formKey}`, null) || formKey;
}

